"use client";

import PublicReportSection from "@/components/report/PublicReportSection";
import type { WebinarRecord } from "@/types/endpoints/assignments/GetWebinarSessions";
import type { CredibilityVerdict } from "@/types/endpoints/assignments/GetAssignmentAttemptDetail";

interface PublicReportTabProps {
  attemptId: number;
  credibility?: number;
  webinarRecords?: WebinarRecord[];
  resultsChart?: Array<{ name: string; data: number[] }>;
  assignmentType?: string;
  credibilityVerdict?: CredibilityVerdict | null;
}

export default function PublicReportTab({
  attemptId,
  credibility,
  webinarRecords,
  resultsChart,
  assignmentType,
  credibilityVerdict,
}: PublicReportTabProps) {
  return (
    <PublicReportSection
      attemptId={attemptId}
      credibility={credibility}
      webinarRecords={webinarRecords}
      resultsChart={resultsChart}
      assignmentType={assignmentType}
      credibilityVerdict={credibilityVerdict}
    />
  );
}
